import { gql } from '@apollo/client';

import { AppMembershipFragment } from './appMemberships.fragment';

export * from './appMembershipUpdate.mutation.generated';

export const APP_MEMBERSHIP_UPDATE = gql`
  mutation appMembershipUpdate($input: AppMembershipUpdateInput!) {
    appMembershipUpdate(input: $input) {
      errors
      success
      appMembership {
        ...AppMembershipFragment
      }
    }
  }
  ${AppMembershipFragment}
`;
